export const issueEntityConfig = {
    entityType: 'issues',
    entityCatalogueConfig: {
        constants: {},
    },
    entityDashboardConfig: {
        constants: {},
        isSavePDFEnabled: false,
        clusters: {
            clustersVisible: false,
            fetchClusters: false,
        },
    },
    entityDataConfig: {
        constants: {
            communicationsLimitMonths: 36,
            lobbyingActivityPeriodMonths: 3,
        },
    },
};
